import React from 'react'

import TextInput from '../../../components/text-input'
import Education from '../education'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import ListLevelHeader from '../../../components/utils/list-element-header'
import DropDown from '../../../components/drop-down'

class LanguageComponent extends Education {
  render() {
    return (
      <React.Fragment>
        <div className="education-container">
          <div className="education-header" onClick={this.toggleBody}>
            <ListLevelHeader
              what={this.state.model.language}
              alternative={this.state.model.fluency}
            />

            <div className="education-header-title education-header-arrow">{this.showArrow()}</div>
          </div>
          <div className={`education-body ${this.state.showBody ? 'open' : 'closed'}`}>
            <div className="section-basics-line">
              <TextInput
                field="language"
                label="Language"
                value={this.state.model.language}
                update={this.update}
              />

              <DropDown
                field="fluency"
                label="Level"
                value={this.state.model.fluency}
                update={this.update}
              />
            </div>
            <div className="button-remove-element" onClick={this.removeElement}>
              <FontAwesomeIcon icon={faTrash} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

LanguageComponent.defaultProperties = { open: false }
export default LanguageComponent
